module.exports = __webpack_public_path__ + "static/media/InSpecIcon.53d52b96.svg";